import clsx from 'clsx';
import React from 'react';

import TrinityAudioPlayer from '@components/TrinityAudio';
import useInlineLinkTracking from '@hooks/useInlineLinkTracking';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { TrackingLocation } from '@tracking';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import styles from './styles.module.scss';

interface BriefingBodyProps {
  body: string;
  isSEOBot: boolean;
  isAudioActive: boolean;
}

const Body = ({ body, isSEOBot, isAudioActive }: BriefingBodyProps) => {
  useInlineLinkTracking({
    trackingLocation: TrackingLocation.ContentBody,
    targetSelector: '.briefing-body',
  });
  const isHydrated = useServerSideRendering();

  return (
    <div
      className={clsx(
        styles.briefingBody,
        'briefing-body clipperable-content break-words font-noto-serif text-body-articles',
        {
          'seo-paywall-content': isSEOBot,
        }
      )}
      data-nosnippet
    >
      <div style={{ order: -1 }}>
        {isAudioActive && isHydrated && (
          <TrinityAudioPlayer
            documentLoadType="onSelectorExists"
            documentLoadTypeSelector=".clipperable-content"
          />
        )}
      </div>

      {AuthoredContentReactToHtmlParser(body)}
    </div>
  );
};

export default Body;
